import { ReactNode } from 'react'
import { Text, Center, Box, HStack } from '@chakra-ui/react'
import { SubscribeInput } from './SubscribeInput'

interface IProps {
  title: string | ReactNode
  subtitle: string | ReactNode
}

export function SubscribeCard({ title, subtitle }: IProps) {
  return (
    <Box
      px={{ base: 8, md: 16 }}
      py={{ base: 8, md: 20 }}
      rounded={'md'}
      bg="blackAlpha.900"
    >
      <Center flexDirection={'column'} justifyItems="center">
        <Text
          variant="spaceGrotesk"
          fontSize={{ base: '24px', md: '32px' }}
          lineHeight="normal"
          color={'white'}
          fontWeight={'semibold'}
          mb={4}
          textAlign="center"
        >
          {title}
        </Text>
        <Text
          fontSize={{ base: '20px', md: '24px' }}
          color={'whiteAlpha.800'}
          lineHeight={1.33}
          textAlign="center"
          mb={4}
        >
          {subtitle}
        </Text>
        <HStack w={{ base: 'full', md: 7 / 12, xl: 7 / 12 }}>
          <SubscribeInput adaptiveColor={false} />
        </HStack>
      </Center>
    </Box>
  )
}
